import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { DirectivesModule } from '../../../../components/directives.module';
import { AudioTemplateEditComponent } from './edit.component';
import { InputTextModule } from '../../../../components/input/input-text';
import { InputSelectModule } from '../../../../components/input/input-select';

const ROUTES: Routes = [
  { path: '', component: AudioTemplateEditComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    InputTextModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
    InputSelectModule,
  ],
  declarations: [AudioTemplateEditComponent],
  exports: [AudioTemplateEditComponent],
})
export class EditModule {}
